import { trait } from '@traits-ts/core'
import type { TaskAssigneeType } from '../../types/task.js'

/**
 * WithAssignment trait
 * Adds assignment capabilities to tasks (assigning to members or subkrewes)
 */
export const WithAssignment = trait(superclass => class extends superclass {
  assignedToId?: string
  assignedToType?: TaskAssigneeType

  /**
   * Assign this task to an entity
   * @param entityId ID of the entity to assign to
   * @param entityType Type of entity (member or subkrewe)
   */
  assign(entityId: string, entityType: TaskAssigneeType): void {
    this.assignedToId = entityId
    this.assignedToType = entityType
  }

  /**
   * Get the entity this task is assigned to
   * @returns Object with id and type of assigned entity, or null if not assigned
   */
  getAssignedTo(): { id: string, type: TaskAssigneeType } | null {
    if (!this.assignedToId || !this.assignedToType) {
      return null
    }

    return {
      id: this.assignedToId,
      type: this.assignedToType,
    }
  }

  /**
   * Check if this task is assigned to a specific entity
   * @param entityId ID to check
   * @param entityType Type to check
   * @returns True if task is assigned to the specified entity
   */
  isAssignedTo(entityId: string, entityType: TaskAssigneeType): boolean {
    return this.assignedToId === entityId && this.assignedToType === entityType
  }
})
